import {twMerge} from 'tailwind-merge';
import React, {FC, useEffect} from 'react';
import {NavLink, Outlet} from 'react-router-dom';
// import {useFeatureFlag} from '../../Managers/FeatureFlags';
import {useCurrentProfile} from '../../react-sdk/queries';
import {CONFIG} from '../../config';
import {URLS} from '../../Routing';

const MenuHeader: FC<{label: string}> = ({label}) => (
  <div className="hidden tablet:block text-[10px] font-medium uppercase tracking-wider text-[#9b9ea8] mt-5 mb-1 px-2.5 first:mt-2">
    {label}
  </div>
);

const MenuItem: FC<{to: string; label: string; disabled?: boolean}> = ({to, label, disabled = false}) => {
  return (
    <NavLink
      className={({isActive}) =>
        twMerge(
          'inline-block tablet:block mx-1 my-0.5 tablet:mx-0 px-2.5 py-[7px] rounded-md text-[13px] font-normal no-underline text-[#474b59] transition-colors',
          !disabled && !isActive ? 'hover:bg-gray-100' : '',
          disabled ? 'cursor-default text-gray-300 hover:bg-transparent' : 'cursor-pointer',
          isActive && !disabled ? 'bg-[#efedfb] text-[#654dcb] font-medium shadow-[inset_3px_0_0_#654dcb]' : '',
        )
      }
      to={to}
    >
      {label}
    </NavLink>
  );
};

export const Settings: FC = () => {
  const currentProfile = useCurrentProfile();
  // const groupsEnabled = useFeatureFlag('group-management', true);
  // const disclaimersEnabled = useFeatureFlag('disclaimer-management', true);
  const groupsEnabled = true;
  const disclaimersEnabled = true;

  const organizationId = currentProfile?.organization_id || '';

  const isPersonal = organizationId === CONFIG.PERSONAL_ORGID;
  const roles = currentProfile?.roles || [];
  const isAdmin = !isPersonal && (roles.includes('owner') || roles.includes('admin'));

  useEffect(() => {
    document.getElementById('verdocs-dropdown-menu-items')?.remove();
  });

  return (
    <div className="flex flex-col tablet:flex-row w-full h-full overflow-y-scroll">
      <div className="flex flex-row flex-wrap pt-2 pb-2 tablet:pt-3 tablet:flex-col bg-[#fbfbfc] tablet:border-r tablet:border-[#ebecf0] px-2 tablet:px-3 flex-[0_0_auto] tablet:flex-[0_0_190px]">
        <MenuHeader label="Personal" />
        <MenuItem to={URLS.SETTINGS_PROFILE.build()} label="My Profile" />
        <MenuItem to={URLS.SETTINGS_SECURITY.build()} label="Security" />

        <MenuHeader label="Organization" />
        <MenuItem to={URLS.SETTINGS_ORGANIZATION.build()} disabled={!isAdmin} label="Org Profile" />
        <MenuItem to={URLS.SETTINGS_BRANDING.build()} disabled={!isAdmin} label="Branding" />
        {disclaimersEnabled && <MenuItem to={URLS.SETTINGS_DISCLAIMER.build()} disabled={!isAdmin} label="Disclosures" />}
        {groupsEnabled && <MenuItem to={URLS.SETTINGS_GROUPS.build()} disabled={!isAdmin} label="Groups" />}
        <MenuItem to={URLS.SETTINGS_MEMBERS.build()} disabled={!isAdmin} label="Members" />
        <MenuItem to={URLS.SETTINGS_API_KEYS.build()} disabled={!isAdmin} label="API Keys" />
        <MenuItem to={URLS.SETTINGS_WEBHOOKS.build()} disabled={!isAdmin} label="Webhooks" />
        <MenuItem to={URLS.SETTINGS_PIPELINE.build()} disabled={!isAdmin} label="Document Processing" />
        <MenuItem to={URLS.SETTINGS_HIERARCHY.build()} disabled={!isAdmin} label="Hierarchy" />
        <MenuItem to={URLS.SETTINGS_USAGE.build()} disabled={!isAdmin} label="Usage" />

        {/*<MenuHeader label="Danger!" />*/}
        {/*<MenuItem to={URLS.SETTINGS_DELETEORG.build()} disabled={!isAdmin} label="Archive Org." />*/}
      </div>

      <div className="flex flex-col h-full p-4 tablet:p-6 flex-1 overflow-x-hidden">
        <Outlet />
      </div>
    </div>
  );
};
